import React, { useState } from "react";
import Styles from "../HomePage/main.module.css";
import { SuccessSwal, warningSwal } from "../../../Util/Toast";
import { gethomecontactform } from "../../../Services/APIrequests";

const Contactform = ({ closeModal }) => {
  const [formData, setFormData] = useState({
    mobileNumber: "",
    name: "",
    email: "",
    location: "",
    subject: "",
    message: "",
  });

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if all fields are filled before submitting
    if (
      !formData.name ||
      !formData.mobileNumber ||
      !formData.email ||
      !formData.location ||
      !formData.subject ||
      !formData.message ||
      !formData.location
    ) {
      warningSwal("All fields are required.");
      return;
    }

    // Prepare the data in the format expected by the API
    const apiData = {
      name: formData.name,
      emailId: formData.email,
      mobileNumber: formData.mobileNumber,
      subject: formData.subject,
      message: formData.message,
      location: formData.location,
    };

    try {
      // Call the API to submit the form data
      const response = await gethomecontactform(apiData);

      // Check if the response status is 201 (success)
      if (response && response.status === 201) {
        SuccessSwal(response.message || "Enquiry form submitted successfully!");
        setFormData({
          mobileNumber: "",
          name: "",
          email: "",
          location: "",
          subject: "",
          message: "",
        });
        closeModal(); // Close modal on success
      } else {
        // If the status is not 201, show warning with the message
        console.error("Error: Unexpected response", response);
        warningSwal(response?.message || "There was an issue with the submission.");
        closeModal(); // Close modal on failure
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      warningSwal("Something went wrong. Please try again later.");
      setFormData({
        mobileNumber: "",
        name: "",
        email: "",
        location: "",
        subject: "",
        message: "",
      });
      closeModal(); // Close modal after error
    }
  };

  return (
    <div className={Styles.formContent}>
      <h2 className={Styles.modalheadingname} style={{ textAlign: 'center', marginBottom: '20px' }}>Inquiry Form</h2>
      <form onSubmit={handleSubmit}>
        <div className={Styles.formGrid}>
          <div className={Styles.formGroup}>
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter Your Name"
              required
            />
          </div>
          <div className={Styles.formGroup}>
            <label>Mobile Number</label>
            <input
              type="text"
              name="mobileNumber"
              value={formData.mobileNumber}
              onChange={handleInputChange}
              placeholder="Enter Mobile Number"
              required
            />
          </div>
          <div className={Styles.formGroup}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Enter Your Email"
              required
            />
          </div>
          <div className={Styles.formGroup}>
            <label>Location</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              placeholder="Enter Your Location"
              required
            />
          </div>
        </div>
        <div className={Styles.formGroup}>
          <label>Subject</label>
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleInputChange}
            placeholder="Enter Subject"
            required
          />
        </div>
        <div className={Styles.formGroup}>
          <label>Message</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            placeholder="Enter Your Message"
            rows={4}
            required
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <button type="submit" className={Styles.submitBtn} style={{ width: '100%', maxWidth: '200px' }}>
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default Contactform;
